// https://apiguide.coingecko.com/getting-started/10-min-tutorial-guide/1-get-data-by-id-or-address
export const CoinIds = {
  ETH: "coingecko:ethereum",
  PNK: "coingecko:kleros",
};
